import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CallModel } from '../shared/models/calllog.model';
import { CommunicationService } from '../shared/services/communication.service';
import { timer, Subscription } from "rxjs";
import { Pipe, PipeTransform } from "@angular/core";
import { debugOutputAstAsTypeScript } from '@angular/compiler';

@Component({
  selector: 'app-call-process',
  templateUrl: './call-process.component.html',
  styleUrls: ['./call-process.component.css']
})
export class CallProcessComponent implements OnInit,  OnDestroy {
  @Input() call : CallModel;
  @Output() onEndCall : EventEmitter<any> = new EventEmitter<any>();
  //call : CallModel;
  //date = new Date('2019-01-26T00:00:00');

 
  countDown: Subscription;
  counter = 0;
  tick = 1000;
 // isEndCall  = false;

  constructor(private commservice : CommunicationService) { 
    console.log("CallProcessComponent : constructor ");
    /*
    commservice.callTransfer.subscribe(data => {
      this.call = data;
      console.log("CallProcessComponent : callTransfer : " + this.call.isEnd);
    });*/
  }

  ngOnInit() {
    console.log("CallProcessComponent(ngOnInit) : client : " + this.call.client.fullName  );
    this.countDown = timer(0, this.tick).subscribe(() => this.counter++);
  }

  onCallEnd()
  {
    //this.call.isEnd = true;
    //this.commservice.sendCallStatus(this.call);
   // this.isEndCall = true;
    this.onEndCall.emit(this.call);
  }

  ngOnDestroy() {
    this.countDown = null;
  }
}

@Pipe({
  name: "formatTime"
})

export class FormatTimePipe implements PipeTransform {
  transform(value: number): string {
    const hours: number = Math.floor(value / 3600);
    const minutes: number = Math.floor((value % 3600) / 60);
    return (
      ("00" + hours).slice(-2) +
      ":" +
      ("00" + minutes).slice(-2) +
      ":" +
      ("00" + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
}
